import { TrackingFunction } from "@webng/liveblog";
import { useChangeBridgeContext } from "@webng/liveblog/src/change-stream/useChangeBridge";
import { useCallback, useEffect, useState } from "react";

export function useVersions(trackingFunction: TrackingFunction) {
  const changeBridgeValue = useChangeBridgeContext();

  if(!changeBridgeValue) {
    throw new Error("ChangeBridgeContext not found");
  }

  const { liveblogLocalId, hasErrored, addEventListener, removeEventListener } = changeBridgeValue;

  const [version, setVersion] = useState<number | undefined>(undefined);

  const onOpen = useCallback(() => {
    trackingFunction({ t: "w_con", url: liveblogLocalId })
  }, [trackingFunction, liveblogLocalId]);

  const onMessage = useCallback((message: any) => {
    if(!message.type.startsWith("v_")) {
      return;
    }

    if (message.type === "v_version") {
      setVersion(message.version);
    }
  }, [setVersion]);

  const onClose = useCallback(() => {
    trackingFunction({ t: "w_dis", s: 1000, url: liveblogLocalId })
  }, [trackingFunction, liveblogLocalId]);

  const onError = useCallback((event: Event) => {
    trackingFunction({ t: "w_err", s: 4002, url: liveblogLocalId })
  }, [trackingFunction, liveblogLocalId]);

  useEffect(() => {
    addEventListener("open", onOpen);
    addEventListener("message", onMessage);
    addEventListener("close", onClose);
    addEventListener("error", onError);

    return () => {
      removeEventListener("open", onOpen);
      removeEventListener("message", onMessage);
      removeEventListener("close", onClose);
      removeEventListener("error", onError);
    };
  }, [onOpen, onMessage, onClose, onError, addEventListener, removeEventListener]);

  if(hasErrored) {
    return undefined;
  }

  return version;
}
